import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ManualDownloadSvg from '../atoms/ManualDownloadSvg'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;

  a {
    margin-bottom: 40px;
    margin-top: 20px;
    background: #ffffff;
    border: #00b5a6 solid 3px;
    border-radius: 10px;
    //padding: 30px 20px;
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    width: 800px;
    height: 100px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    word-break: keep-all;

    &:hover {
      box-shadow: 2px 2px 5px transparent;
      text-decoration: underline solid transparent;
    }

    .title-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .title-wrap h2 {
      margin-left: 10px;
      font-size: 26px;
      color: #414141;
      margin-bottom: 5px;
    }

    .txt-wrap {
      text-align: start;
      line-height: normal;
      color: #707070;
      margin-left: 20px;
    }

    svg {
      height: 50px;
      width: 50px;
    }
  }

  ${BreakPoints.xLarge} {
    a {
      width: 80%;
    }

    .title-wrap h2 {
      font-size: 22px !important;
    }

    .txt-wrap {
      font-size: 14px;
    }
  }

  ${BreakPoints.large} {
    a {
      width: 86vw;
      margin: 30px 7vw 40px;
      height: 80px;
    }

    .title-wrap h2 {
      font-size: 20px !important;
    }

    .txt-wrap {
      font-size: 12px;
    }
  }

  ${BreakPoints.medium} {
    a {
      padding: 0 10px;
    }

    .title-wrap {
      margin-bottom: -5px;
    }

    .title-wrap h2 {
      font-size: 18px !important;
    }

    svg {
      height: 40px !important;
      width: 40px !important;
    }

    .txt-wrap {
      font-size: 10px;
      margin-left: 10px !important;
    }
  }
`

/**
 * マニュアルダウンロード
 * @constructor
 */
const ManualBtn = () => (
  <Wrapper>
    <a href="/help/manual-download/">
      <div className="title-wrap">
        <ManualDownloadSvg />
        <h2>キンクラマニュアル</h2>
      </div>
      <div className="txt-wrap">
        <p>
          従業員向け・管理職向け・システム管理者向けの
          <br />
          マニュアルのダウンロードが行えます。
        </p>
      </div>
    </a>
  </Wrapper>
)

export default ManualBtn
